import { Cell, Grid, Heading } from 'bold-ui'
import { RadioGroupField } from 'components/form'

import { MamografiaPerguntaField } from '../model-mamografia'
import { MamografiaIndicacaoClinicaAccordion } from './MamografiaIndicacaoClinicaAccordion'
import { MamografiaIndicacaoClinicaMamaAccordion } from './MamografiaIndicacaoClinicaMamaAccordion'
import {
  avaliacaoRespostaQuimioterapiaOptions,
  controleRadioAccordionOptions,
  lesaoBenignaAccordionOptions,
  lesaoCancerAccordionOptions,
  revisaoMamografiaLesaoAccordionOptions,
} from './model-indicacaoClinica'

export function MamografiaIndicacaoClinicaDiagnosticaFormSection() {
  return (
    <Grid>
      <Cell size={12}>
        <Heading level={3} color='normal' fontWeight='bold'>
          Mamografia diagnóstica
        </Heading>
      </Cell>
      <Cell size={12}>
        <Heading level={3} color='normal' fontWeight='bold'>
          Achados no exame clínico
        </Heading>
      </Cell>
      <Cell size={12} data-testid='mamaDireita'>
        <MamografiaIndicacaoClinicaMamaAccordion
          uuid='mamaDireita'
          title='Mama direita'
          names={{
            lesaoPapilar: MamografiaPerguntaField.lesaoPapilarDireita,
            descargaPapilar: MamografiaPerguntaField.descargaPapilarDireita,
            noduloLocalizacao: MamografiaPerguntaField.noduloLocalizacaoDireita,
            espessamentoLocalizacao: MamografiaPerguntaField.espessamentoLocalizacaoDireita,
            linfonodoPalpavel: MamografiaPerguntaField.linfonodoPalpavelDireita,
          }}
        />
      </Cell>
      <Cell size={12} data-testid='mamaEsquerda'>
        <MamografiaIndicacaoClinicaMamaAccordion
          uuid='mamaEsquerda'
          title='Mama esquerda'
          names={{
            lesaoPapilar: MamografiaPerguntaField.lesaoPapilarEsquerda,
            descargaPapilar: MamografiaPerguntaField.descargaPapilarEsquerda,
            noduloLocalizacao: MamografiaPerguntaField.noduloLocalizacaoEsquerda,
            espessamentoLocalizacao: MamografiaPerguntaField.espessamentoMamaEsquerda,
            linfonodoPalpavel: MamografiaPerguntaField.linfonodoPalpavelEsquerda,
          }}
        />
      </Cell>
      <Cell size={12} data-testid='controleRadio'>
        <MamografiaIndicacaoClinicaAccordion
          uuid='controleRadio'
          options={controleRadioAccordionOptions}
          title='Controle radiológico Categoria BI RADS 3'
        />
      </Cell>
      <Cell size={12} data-testid='lesaoCancer'>
        <MamografiaIndicacaoClinicaAccordion
          uuid='lesaoCancer'
          options={lesaoCancerAccordionOptions}
          title='Lesão com diagnóstico de câncer'
        />
      </Cell>
      <Cell size={12} data-testid='avaliacaoRespostaQuimioterapia'>
        <RadioGroupField
          name={MamografiaPerguntaField.avaliacaoRespostaQuimioterapia}
          label='Avaliação da resposta de quimioterapia neoadjuvante'
          options={avaliacaoRespostaQuimioterapiaOptions}
          clearable
        />
      </Cell>
      <Cell size={12} data-testid='revisaoMamografiaLesao'>
        <MamografiaIndicacaoClinicaAccordion
          uuid='revisaoMamografiaLesao'
          options={revisaoMamografiaLesaoAccordionOptions}
          title='Revisão de mamografia com lesão, realizada em outra instituição'
        />
      </Cell>
      <Cell size={12} data-testid='lesaoBenigna'>
        <MamografiaIndicacaoClinicaAccordion
          uuid='lesaoBenigna'
          options={lesaoBenignaAccordionOptions}
          title='Controle de lesão após biópsia de fragmento ou PAAF com resultado benigno'
        />
      </Cell>
    </Grid>
  )
}
